<template>
  <b-modal :id="id"
           lazy
           centered
           ok-variant="ls"
           size="lg"
           title="Zainstaluj aplikację"
           cancel-title="Nie pokazuj ponownie"
           footer-class="justify-content-between"
           :ok-title="okTitle"
           @cancel="neverShowAgain"
           @ok="install"
           hide-header
           no-stacking
  >
    <div class="d-flex justify-content-center mt-2">
      <div class="icon">
        <div class="logo d-flex text-center">
          <img :src="icon" :alt="title">
        </div>
      </div>
    </div>
    <div class="p-3 text-center mt-1">
      <h3>Zainstaluj aplikację {{ title }}</h3>
      <p>Dodaj aplikację do ekranu głównego, aby mieć ją zawsze pod ręką.</p>
    </div>
    <!--  iOS  -->
    <div v-if="isIphone" class="how-to">
      <ul>
        <li v-if="!isSafari">Otwórz stronę w przeglądarce Safari</li>
        <li>Naciśnij <img class="ml-1" src="@/assets/iOS-share.jpeg" width="15" height="20" alt="" style="margin-top: -5px"></li>
        <li>Następnie wybierz <strong>„Do ekranu początkowego”</strong></li>
      </ul>
    </div>

    <div v-if="isAndroid && !beforeInstallEvent" class="how-to">
      <ul>
        <li>Naciśnij <img class="ml-1" src="@/assets/chrome-options.jpeg" width="15" height="20" alt="" style="margin-top: -2px"></li>
        <li v-if="isChrome">Następnie wybierz <strong>„Dodaj do ekranu głównego”</strong></li>
        <li v-if="isSamsungInternet">Następnie wybierz <strong>„Dodaj do ekranu startowego”</strong></li>
        <li v-if="isFirefox">Następnie wybierz <strong>„Zainstaluj”</strong></li>
        <li v-if="isOpera">Następnie wybierz <strong>„Ekran główny”</strong> w sekcji „Dodaj do”</li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
  import {mapState} from "vuex";
  export default {
    name: "InstallPwaModal",
    data() {
      return {
        id: 'install-pwa-modal',
        beforeInstallEvent: null,
        timeout: 3000,
        isOpen: false,
      }
    },
    mounted() {
      if (!this.isIphone && !this.isAndroid) {
        return false;
      }

      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.beforeInstallEvent = e;
        this.showWithTimeout();
      });

      if (!this.isBrowserAllowed) {
        return false;
      }

      if (this.isAndroid && this.isChrome) {
        return false;
      }

      if (this.isPwa || this.isWebkit) {
        return false;
      }

      this.showWithTimeout();
    },
    methods: {
      neverShowAgain() {
        localStorage.setItem(this.dismissStorageKey, true);
      },
      install() {
        if (this.beforeInstallEvent) {
          this.$bvModal.hide(this.id);
          this.beforeInstallEvent.prompt();
        }
      },
      showWithTimeout() {
        if (this.dismissModal) {
          return false;
        }

        setTimeout(() => this.$bvModal.show(this.id), this.timeout);
      },
    },
    computed: {
      ...mapState({
        isPwa: state => state.browser.isPwa,
        isWebkit: state => state.browser.isWebkit,
        isIphone: state => state.browser.isIphone,
        isAndroid: state => state.browser.isAndroid,
        isChrome: state => state.browser.isChrome,
        isFirefox: state => state.browser.isFirefox,
        isOpera: state => state.browser.isOpera,
        isSafari: state => state.browser.isSafari,
        isSamsungInternet: state => state.browser.isSamsungInternet,
        isBrowserAllowed: state => state.browser.isBrowserAllowed,
        entityUuid: state => state.auth.entity.uuid,
        favicons: state => state.settings.favicons,
        title: state => state.settings.title,
      }),
      dismissStorageKey() {
        return `ls-dismiss-app-install-${this.entityUuid}`;
      },
      dismissModal() {
        return localStorage.getItem(this.dismissStorageKey) === 'true';
      },
      okTitle() {
        return this.beforeInstallEvent ? 'Zainstaluj' : 'Zamknij';
      },
      icon() {
        return this.favicons
          ? this.favicons['180']
          : `${process.env.VUE_APP_PUBLIC_PATH}/apple-touch-icon-180x180.png`;
      },

    }
  }
</script>

<style scoped>
  .icon {
    width: 120px;
    height: 120px;
    padding: 15px;
    background: #efefef;
    border-radius: 25px;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .logo img {
    width: 90px;
    height: auto;
    max-height: 90px;
  }

  .how-to {
    font-size: 15px;
  }
</style>
